import { formatDate } from "@angular/common";
import {
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  Type,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";
import * as _ from "lodash";
import { AdminEditTruckownerDoComponent } from "../admin-edit-truckowner-do/admin-edit-truckowner-do.component";

@Component({
  selector: "app-admin-view-work-order",
  templateUrl: "./admin-view-work-order.component.html",
  styleUrls: ["./admin-view-work-order.component.css"],
})
export class AdminViewWorkOrderComponent implements OnInit {
  workorderForm: FormGroup;
  enabledetails: boolean = false;
  doDetails: any = this.work_order?.doInfo != "";
  dropAutoComplete: any;
  pickupAutoComplete: any;
  pickupLat: any;
  pickupLong: any;
  dropLat: any;
  dropLong: any;
  completeDropAddress: any;
  completePickUpAddress: any;
  pickup_long_name: any = "";
  pickup_short_name: any = "";
  drop_long_name: any = "";
  drop_short_name: any = "";
  pickup_postal_code: any;
  dropoff_postal_code: any;
  @ViewChild("pickUpLocationSearchField")
  pickUpLocation: ElementRef | any;
  @ViewChild("dropLocationSearchField")
  dropLocation!: ElementRef;
  @Input() min: any;
  minDate = new Date();
  @Input() max: any;
  maxDate = new Date();
  truckCategory: any = [];
  loadCategory: any;
  token: any;
  loadCategorySelectedindex: any;
  loadSelectedCategory: any;
  materialDetails: any;
  otherValue: any;
  customerName: any = [];
  corporate_name: any = [];
  workorderArray: any;
  vehicleArray: any;
  issuedQty: any;
  availableQty: any;
  unloadingQty: any;
  loadingQty: any;
  usedDO: any;
  dodetailsArray: any;
  selectedWorkOrderQty: any;
  total_quantity: any;
  work_order_msg: any;
  dateFormat = "yyyy-MM-dd";
  language = "en";
  selectCatgValue: any;
  vehiclelists: any;
  truckArray: any;
  work_order_qty: any;
  workOrderQnty: any;
  selectedLoadedQuantity: any;
  perPage: any = 10;
  customerListPerPage: any = 9999;
  startPage: any = 1;
  searchLoadType: any = -1;
  page: any = 1;
  customerMobile = -1;
  searchWorkOrder: any = -1;
  loading: boolean = false;
  user_id: any;
  selectedWOType: any = "present_work_order";
  constructor(
    private formBuilder: FormBuilder,
    private matDialog: MatDialog,
    private matdialogref: MatDialogRef<AdminEditTruckownerDoComponent>,
    private matdialogre: MatDialogRef<AdminViewWorkOrderComponent>,
    private services: AdminService,
    private snackBar: MatSnackBar,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public work_order: any
  ) {}
  ngOnInit(): void {
    this.issuedQty = _.sumBy(this.work_order.doInfo, "do_quantity");
    this.availableQty = _.sumBy(this.work_order.doInfo, "remaining_tons");
    this.usedDO = this.issuedQty - this.availableQty;
    this.token = localStorage.getItem("adminToken");
    this.workorderForm = this.formBuilder.group({
      from_area_name: new FormControl(
        null,
        Validators.compose([Validators.required])
      ),
      to_area_name: new FormControl(
        null,
        Validators.compose([Validators.required])
      ),
      pickup_date: [""],
      truck_category: ["", [Validators.required]],
      total_tons: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(/^(0|[1-9]\d*)$/),
        ]),
      ],

      price_per_ton: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(/^(0|[1-9]\d*)$/),
        ]),
      ],
      material: ["", Validators.compose([Validators.required])],

      username: ["", Validators.required],
      pickup_name: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(/^[a-zA-Z][a-zA-Z\\s]+$/),
        ]),
      ],
      address_line: ["", Validators.compose([Validators.required])],
      pickup_contact: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]{4,10}$"),
        ]),
      ],
      city: [
        "",
        [Validators.required, Validators.pattern("^[a-zA-Z][a-zA-Z\\s]+$")],
      ],

      dropoff_name: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(/^[a-zA-Z][a-zA-Z\\s]+$/),
        ]),
      ],
      state: [
        "",
        [Validators.required, Validators.pattern("^[a-zA-Z][a-zA-Z\\s]+$")],
      ],
      pincode: ["", [Validators.required, Validators.pattern("^[0-9]{6,6}$")]],
      dropoff_contact: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]{4,10}$"),
        ]),
      ],
      pay_as_load_quantity: [""],
    });
    this.getCustomerList();
  }

  workOrder(type: any) {
    this.searchWorkOrder = type;
    this.loading = true;
    this.services
      .workOrderList(
        this.token,
        this.selectedWOType,
        this.searchWorkOrder,
        this.perPage,
        this.startPage
      )
      .subscribe(
        (response: any) => {
          this.workorderArray = response.body.data;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.workorderArray = [];
          if (error.status == 404) {
            return;
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  getCustomerList() {
    this.services
      .getUsersCustomers(
        this.token,
        this.customerListPerPage,
        this.startPage,
        this.customerMobile
      )
      .subscribe(
        (response: any) => {
          let customerdata: any;
          customerdata = response.body.data;
          for (var i = 0; i < customerdata.length; i++) {
            if (customerdata[i].user_type == "corporate") {
              this.corporate_name.push(customerdata[i]);
            }
            this.corporate_name.filter((ele: any) => {
              if (ele._id == this.work_order.user_id) {
                this.user_id = ele;
              }
            });
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  editTruckOwner(item: any) {
    if (item) {
      this.matdialogre.close();
    }
    let data = {
      workOrderNo: this.work_order.workorder_id,
      actualPrice: this.work_order.price_per_ton,
      workorderDate: this.work_order.createdAt,
      workorderqty: this.work_order.total_tons,
      availableqty: this.work_order.remaining_tons,
      doInfo: item,
    };
    this.matdialogref = this.matDialog.open(AdminEditTruckownerDoComponent, {
      width: "80vw",
      height: "80vh",
      autoFocus: false,
      data: data,
    });
    this.matdialogref.afterClosed().subscribe((x) => {
      this.workOrder(this.searchWorkOrder);
    });
  }

  close() {
    this.matdialogre.close({ event: "close" });
  }
}
